import { action } from 'satcheljs/lib/legacy';
import RightsManagementFailureCode from 'owa-mail-store/lib/store/schema/RightsManagementFailureCode';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import type RightsManagementLicenseDataType from 'owa-service/lib/contract/RightsManagementLicenseDataType';
import type ProtectionViewState from 'owa-mail-protection-types/lib/schema/ProtectionViewState';

export default action('setIRMData')(function setIRMData(
    protectionViewState: ProtectionViewState,
    IRMData: RightsManagementLicenseDataType | null
) {
    if (canSetIRMData(protectionViewState)) {
        if (IRMData) {
            protectionViewState.IRMData = IRMData;
        } else if (protectionViewState.IRMData) {
            // If there was IRM data, just set template id to null so that when save draft/send, we know we need to clear the compliance id
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (19,13): Type 'null' is not assignable to type 'string | undefined'.
            // @ts-expect-error
            protectionViewState.IRMData.RmsTemplateId = null;
        }
    }
});

function canSetIRMData(protectionViewState: ProtectionViewState): boolean {
    const config = getUserConfiguration();
    if (config.SegmentationSettings && !config.SegmentationSettings.Irm) {
        return false;
    }

    const { IRMData } = protectionViewState;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (34,5): Type 'boolean | undefined' is not assignable to type 'boolean'.
    // @ts-expect-error
    return (
        IRMData == null ||
        (IRMData.RightsManagedMessageDecryptionStatus &&
            IRMData.RightsManagedMessageDecryptionStatus != RightsManagementFailureCode.Success) ||
        IRMData.IsOwner ||
        IRMData.ExportAllowed
    );
}
